<template>
  <main>
    <PageIntro v-if="appLogin === false" :heading="'Register for a <span>' + configStrings.productName + '</span> '"
      :body="'<p>Please enter your details below to set up your ' + configStrings.productName + ' .</p><p>Once registered, your account lets you take advantage of a range of supporter benefits, all in one place, such as being able to buy tickets online, manage your purchases, and enjoy access to exclusive ' + configStrings.clubName + ' content. </p><p>You only need to register once with your details, and you can update your details and preferences at any time.</p>'" />
    <PageIntro v-else :heading="'Register for a <span>' + configStrings.productName + '</span> '" :body="''" />
    <Registration />
    <FooterShout v-if="appLogin === false" :type="'signin'" />
  </main>
</template>

<script>
import Registration from '@/components/Registration'
import PageIntro from '@/components/PageIntro'
import FooterShout from '@/components/FooterShout'

export default {
  components: {
    Registration,
    PageIntro,
    FooterShout
  },
  data() {
    return {
      appLogin: false
    }
  },
  mounted() {
    // if they are coming from the app specific login URL adapt the page accordingly
    if (this.$router.currentRoute.name === 'app-register') {
      this.appLogin = true
    }
  },
}
</script>
